import {isSet} from "./commonUtil";

export const maxString = (value, maxLength = 50) => {
    if (!isSet(value)) {
        return value;
    }
    if (value.length > maxLength) {
        return value.substring(0, maxLength - 3) + "...";
    }
    return value;
};
